import * as React from "react";
import ResultsPanel, {CommonResultsPanelProps, ItemsRenderer} from "../results_panel";
import PopupItemText from "../popup_item_text";
import clsx from "clsx";

import type BookmarksModel from "./bookmarks_model"
import {BookmarkItem} from "./bookmarks_model"
import BookmarkRenderer from "./bookmark_renderer"

interface BookmarksProps extends CommonResultsPanelProps {

    model: typeof BookmarksModel;

    /**
     * Index of item which should be selected
     */
    selectedIndex: number;

    /**
     * Optional callback for custom bookmark selection handling.
     * When provided, called instead of the default bm.open() behavior.
     */
    onBookmarkSelected?: (bookmark: maxkir_Bookmark) => void;
}

// Component to render list of actions
export default (props: BookmarksProps) => {
    // maxkir.warn("items rerendered: ", props.items)

    const doOpenItem = (elementId: string, _e: Event) => {
        if (!elementId.startsWith("bookmark_")) return;

        const bm = maxkir.Bookmarks.find_bookmark_by_id(elementId.substring("bookmark_".length));
        if (!bm) return;

        props.onBeforeItemOpen(true);
        if (props.onBookmarkSelected) {
            props.onBookmarkSelected(bm);
        } else if (!maxkir.is_testing()) {
            bm.open();
        }
    }

    return <ResultsPanel
        cssClass="bookmarksList"
        itemsRenderer={new BookmarksRenderer(props)}
        doOpenItem={doOpenItem}
        {...props}
    />
}


class BookmarksRenderer implements ItemsRenderer {
    _result: JSX.Element[];
    private _selectedElementId: string;

    constructor(props: BookmarksProps) {

        const selectedIndex = props.selectedIndex;
        const filterTerms = props.model.getFilterTerms();

        this._result = [];
        const highlighter = (text) => {
            return <PopupItemText text={text} filterTerms={filterTerms}/>
        }

        props.model.getFoundItems().forEach((item: BookmarkItem) => {

            const clz = this._clz(selectedIndex);

            this._result.push(
                <BookmarkRenderer bookmarkItem={item} extraLiClass={clz}
                                  filterText={ filterTerms.join(" ")}
                                        highlighter={highlighter}/>
            );

            if (clz.indexOf('selected') >= 0) {
                this._selectedElementId = "bookmark_" + item.id;
            }
        });

        if (this._result.length === 0) {
            this._result.push(<li className='searchEverywhere__nothingFound'>
                <i className="far fa-empty-set"></i>
                {I18N(props.model.hasNoData() ? "js_no_bookmarks" : "js_nothing_found")}
            </li>);
        }
    }

    _clz(selectedIndex: number): string {
        return clsx('searchEverywhere__li',
            this._result.length === selectedIndex ? 'selected' : null);
    }

    getSelectedElementId(): string {
        return this._selectedElementId;
    }

    getVisibleCount(): number {
        return this._result.length;
    }

    renderItems(): JSX.Element[] {
        return this._result;
    }
}
